import React, { useState } from "react";
import { string } from "prop-types";
import { Row } from "simple-flexbox";
import { connect } from "react-redux";
import Popup from "../../utilities/Popup";
import history from "../../../router/browserrouter";
import ChangeUserPasswordForm from "../main/employee/ChangeUserPasswordForm";
import { selectCartItemsCount } from "../../../redux-store/reducers/cart-reducer/cart.selector";
import "./header.styles.scss";
import { Link } from "react-router-dom";
import Avatar from "../../../assets/images/avatar.png";
import SettingsApplications from "@material-ui/icons/SettingsApplications";
import PowerSettingsNew from "@material-ui/icons/PowerSettingsNew";
import LogoutModal from "./LogoutModal";

function logout() {
  localStorage.clear();
}
function HeaderComponent(props) {
  const { icon, title, ClearCart, ...otherProps } = props;
  const [openPopup, setOpenPopup] = useState(false);
  const [logout, setLogout] = useState(false);

  var roles = roles;
  return (
    <Row
      style={{ height: "60px", backgroundColor: "#141b28" }}
      vertical="center"
      horizontal="space-between"
      className="top-row"
      {...otherProps}
    >
      <span className="title"></span>
      <Row vertical="center">
        {/* {roles.includes("Sales Representative", "App Owner") ? ( */}
        <i
          style={{ margin: "4rem", cursor: "pointer", color: "white" }}
          onClick={() => {
            history.push("/checkout");
          }}
          className="fas fa-shopping-cart"
        >
          {parseFloat(props.itemCount)}
        </i>
        {/* ) : (
          ""
        )} */}

        {/* User Image */}
        <div style={{ marginLeft: "-4rem" }} className="p-4">
          <div className="dropdown flex flex-row items-center">
            <span className="text-white mr-1">
              <strong> {props.firstname}</strong>{" "}
            </span>
            <img className="pr-5" src={Avatar} alt="img" width="50px" />
            <SettingsApplications
              className="text-white mr-2"
              onClick={() => setOpenPopup(true)}
              style={{ cursor: "pointer" }}
            />

            <Link
              className="dropdown-item powerIcon d-inline"
              onClick={() => {
                ClearCart();
                localStorage.clear();
                localStorage.removeItem("persist:root");
                history.push("/user/login");
              }}
            >
              <PowerSettingsNew className="text-green-500" title="Log out" />
            </Link>

            <Popup
              title="Logout Form"
              openPopup={logout}
              setOpenPopup={setLogout}
            >
              <LogoutModal setOpenPopup={setLogout} />
            </Popup>
          </div>
        </div>
        <div className="seperator"></div>
        <div className="seperator"></div>
      </Row>
      <Popup
        title="Update Password Form"
        setOpenPopup={setOpenPopup}
        openPopup={openPopup}
      >
        <ChangeUserPasswordForm setOpenPopup={setOpenPopup} />
      </Popup>
    </Row>
  );
}

HeaderComponent.propTypes = {
  title: string,
};

const mapToDispatchToProps = (dispatch) => ({
  ClearCart: () => dispatch({ type: "CLEAR_CART" }), //setting the values,
});
function mapStateToProps(state) {
  return {
    firstname: state.userReducer.firstName,
    itemCount: selectCartItemsCount(state),
    roles: state.persistReducer.roles,
  };
}

export default connect(mapStateToProps, mapToDispatchToProps)(HeaderComponent);
